import { useState, useCallback } from "books/act";
import { Link, Box, useTheme } from "fashion/fabrics";

const EMBED_LINK_HREF = "https://betalist.com/startups/card-memoir";
const EMBED_IMG_LIGHT =
  "https://betalist.com/badges/featured?id=121346&theme=color";
const EMBED_IMG_DARK =
  "https://betalist.com/badges/featured?id=121346&theme=dark";

const EMBED_WIDTH = 156;
const EMBED_HEIGHT = 54;

const CodexEmbedBetaList = () => {
  const [embedError, setEmbedError] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const handleError = useCallback(() => setEmbedError(true), []);

  return embedError ? null : (
    <Box
      component={Link}
      target="_blank"
      href={EMBED_LINK_HREF}
      rel="noreferrer"
      width={EMBED_WIDTH}
      height={EMBED_HEIGHT}
    >
      <img
        src={isDarkMode ? EMBED_IMG_DARK : EMBED_IMG_LIGHT}
        alt="Social Badge"
        width={EMBED_WIDTH}
        height={EMBED_HEIGHT}
        onError={handleError}
      />
    </Box>
  );
};

export default CodexEmbedBetaList;
